<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    :clear-on-destroy="!isEdit"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <PTOProjectTitle v-if="isEdit" is-edit />

    <VInput
      label="№ заказа"
      name="order_number"
    />

    <AppInputDate
      title="Дата заказа"
      name="order_date"
      type="single"
    />

    <VSelect
      label="Ответственный"
      name="responsible"
      :items="userList"
      :handler-search="GETUserList"
      search
      userSelect
    />

    <VInput
      label="Объем"
      name="volume"
    />

    <VSelect
      label="Ед. изм."
      name="measure_unit"
      :items="measureUnitList"
      :handler-search="GETMeasureUnitList"
      search
    />

    <AppInputFile
      title="Загрузите файл"
      class="form__input--col-2"
      name="files"
      @delete-file="ADD_FILE_TO_DELETE"
    />

    <VInput
      label="Примечание"
      class="form__input--col-2"
      name="note"
      type="textarea"
    />
  </FormPto>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import AppInputFile from '@/components/page/input/AppInputFile'
import FormPto from '@/components/pto/form/FormPto'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect.vue'

import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'

import { mapMutations, mapState, mapActions } from 'vuex'
import { prepareProjectPtoCMKFormData } from '@/utils/page/pto/project/pto'

export default {
  name: 'FormPtoProjectPtoCMK',
  components: {
    AppInputDate,
    AppInputFile,
    FormPto,
    PTOProjectTitle,
    VInput,
    VSelect
  },

  mixins: [
    MIXIN_FORM_PTO,
    MIXIN_USER_LIST
  ],

  computed: {
    ...mapState('handbook/pto', {
      measureUnitList: 'measureUnitList'
    })
  },

  destroyed () {
    this.RESET_FILES_TO_DELETE()
  },

  methods: {
    ...mapMutations('pto/project/pto/cmk', {
      RESET_FILES_TO_DELETE: 'RESET_FILES_TO_DELETE',
      ADD_FILE_TO_DELETE: 'ADD_FILE_TO_DELETE'
    }),
    ...mapActions('handbook/pto', {
      GETMeasureUnitList: 'GETMeasureUnitList'
    }),

    onSubmit (data) {
      this.$emit('request', prepareProjectPtoCMKFormData(data))
    }
  }
}
</script>
